if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){



    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    $("#btn-menu-js").click(function(){
        $(".menu-block").addClass("active");
        $(".menu-block-shadow").addClass("active");
    });
    
    $(".menu-block__close").click(function(){
        $(".menu-block").removeClass("active");
        $(".menu-block-shadow").removeClass("active");
    });


   //CMS forms label animation
   if(document.getElementsByClassName('form-module__field').length > 0){
        let allffields = document.getElementsByClassName('form-module__field');
        
        for(let j = 0; j < allffields.length; j++){
            
            if(allffields[j].getElementsByTagName('input').length > 0){
                if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
                    allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
                        this.parentElement.classList.add('moved');
                    })
                }
            }
            if(allffields[j].getElementsByTagName('select').length > 0){
                allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
            if(allffields[j].getElementsByTagName('textarea').length > 0){
                allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
                    this.parentElement.classList.add('moved');
                })
            }
         }
    }

    let burguer = document.getElementById('burgerMenu');
    if(burguer){

  
        burguer.addEventListener('click', function () {
            if (!this.classList.contains('open')) {
                this.parentElement.classList.add('open');
                this.classList.add('open');
                document.querySelector(".overlay").classList.add("open");
                document.getElementById("logo-sm").classList.remove("hidden");
                let button = document.getElementById("Close").parentElement.parentElement;
                if (button.childNodes.length == 2) {
                    let newText = document.createElement("div");
                    newText.textContent = "CLOSE";
                    newText.classList.add("jsCloseBtn")
                    button.appendChild(newText);
                }
            }
             else {
                this.classList.remove('open');
                document.getElementById("logo-sm").classList.add("hidden");
                let button = document.getElementById("Close").parentElement.parentElement;
                button.removeChild();
                this.parentElement.classList.remove('open');
                document.querySelector(".overlay").classList.remove("open");
            }
        });
        // close btn mobile
        let closeBtn = document.querySelectorAll(".nav-container")[0];
        let newButton = closeBtn.childNodes[1];
        if (newButton != undefined) {
            if (closeBtn.childNodes[1].classList.contains("mobile")) {
                let generalbutton = closeBtn.childNodes[1].children[0].children[0];
                generalbutton.addEventListener('click', function () {
                    document.getElementById("logo-sm").classList.add("hidden");
                    document.querySelectorAll('.overlay')[0].classList.remove('open');
                    document.getElementById('burgerMenu').classList.remove('open');
                })
            }
        } 
    }

})();
/** ADA - Add aria-label to Logo and Navigation Footer **/

document.addEventListener("DOMContentLoaded", function(){
    const logoHeader = document.querySelector(".header__center a.header__logo");
    const secondaryNavFooter = document.querySelector(".footer #secondary-nav")

    if(logoHeader){
        logoHeader.setAttribute("aria-label", "Chateau on the Lake logo");
    }
    
    if(secondaryNavFooter){
        secondaryNavFooter.setAttribute("aria-label", "Secondary Footer Navigation");
    }

});

/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/
function updateMenuTabIndex() {
    const menu = document.querySelector('#menu-block');
    const isMenuVisible = menu && menu.classList.contains('active');
    const elements = document.querySelectorAll('.privary-navigation__item a, .secondary-navigation__item a');

    elements.forEach(element => {
        element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
    });
}
document.addEventListener('DOMContentLoaded', () => {
    updateMenuTabIndex();

    document.addEventListener('focusin', updateMenuTabIndex);
    const menu = document.querySelector('#menu-block');
    if (menu) {
        menu.addEventListener('transitionend', updateMenuTabIndex);
    }
});